export interface IBillPayment {
  paymentTime: string,
  paymentMethod: string
}

export enum BillRecurringEventType {
  ONE_TIME = 'ONE_TIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export interface IRecurringPaymentData {
  paymentFrequency?: BillRecurringEventType,
  recurringNumber?: number,
  recurringIndex?: number,
  recurringGroupId?: string
}

export interface IPaymentReminderData {
  paymentReminderEnabled: boolean
}

export interface IBillVendorRequestData {
  creationDate: string,
  expirationDate: string
}

export interface IBillItem {
  amount: number,
  billId: string,
  billNumber: string,
  createTime: string,
  currencyCode: string,
  documentId: string,
  dueDate: string,
  payments?: Array<IBillPayment>
  calculatedStatus: string,
  isSupportRequestVendorDetails: boolean,
  supplierId: string,
  supplierName: string,
  updateTime: string,
  paidTime?: string,
  cancelTime?: string,
  contentType: string,
  recurringPaymentData?: IRecurringPaymentData,
  paymentReminderData?: IPaymentReminderData,
  billVendorRequestData?: IBillVendorRequestData
}

export interface IBillAction {
  name: string,
  title: string,
  SVGIcon: any,
  width?: string,
  key: string
}

export enum PaymentMethods {
  ACH = 'ACH',
  WIRE = 'WIRE',
  CHECK = 'CHECK',
  ASK_VENDOR = 'ASK_VENDOR',
  INTERNATIONAL_WIRE = 'INTERNATIONAL_WIRE'
}
